/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// core components
import Admin from "./layouts/Admin.js";
import "./assets/css/material-dashboard-react.css?v=1.10.0";
import InactivityTimeout from "./views/Timer/InactivityTimer";

const container = document.getElementById("root");

const root = createRoot(container);

// Register the service worker if supported
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

//     navigator.serviceWorker
//       .register(swUrl)
//       .then((registration) => {
//         console.log(
//           "Service Worker registered with scope: ",
//           registration.scope
//         );
//       })
//       .catch((error) => {
//         console.error("Service Worker registration failed: ", error);
//       });
//   });
// }

root.render(
  <BrowserRouter>
    <InactivityTimeout>
      <Switch>
        <Route path="/admin" component={Admin} />
        <Redirect from="/" to="/admin/dashboard" />
      </Switch>
    </InactivityTimeout>
  </BrowserRouter>
);

